/**
 * Add if not exist or remove if exist event slug in multiple select action
 *
 * @param {Object} state
 * @param {string} eventSlug      - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @return {*}
 */
function eventToggleMultipleSelect(state, eventSlug) {
    let multipleSelect = [ ...state.multipleSelect ]

    if (multipleSelect.some(select => select === eventSlug)) {
        multipleSelect = multipleSelect.filter(select => select !== eventSlug)
    } else {
        multipleSelect = [ ...multipleSelect, eventSlug ]
    }

    return {
        ...state,
        multipleSelect: multipleSelect,
    }
}

/**
 * Clear multiple selected events
 *
 * @param {Object} state
 * @return {*}
 */
function eventClearMultipleSelect(state) {
    return {
        ...state,
        multipleSelect: [],
    }
}

export const EVENTS_ADMIN_TOGGLE_MULTIPLE_SELECT = 'EVENTS_ADMIN_TOGGLE_MULTIPLE_SELECT'
export const EVENTS_ADMIN_CLEAR_MULTIPLE_SELECT = 'EVENTS_ADMIN_CLEAR_MULTIPLE_SELECT'

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function (state = [], action) {
    switch (action.type) {
        case EVENTS_ADMIN_TOGGLE_MULTIPLE_SELECT: return eventToggleMultipleSelect(state, action.eventSlug)
        case EVENTS_ADMIN_CLEAR_MULTIPLE_SELECT: return eventClearMultipleSelect(state)
        default: return state
    }
}
